models.service('ClosedTradeModel', [
    '$filter', 'constants', 'AssetService', 'InvestCalcService', 'CurrencyConvertService', 'UserService',
    function ($filter, Const, AssetService, InvestCalcService, CurrencyConvertService, UserService) {

        function ClosedTrade(positionData) {
            var self = this,
                asset;

            self.user = UserService.get();
            self.orderId = positionData.OrderID;
            self.openPrice = positionData.OpenPrice;
            self.openTime = parseInt(positionData.OpenTime + '000', 10);
            self.closePrice = positionData.ClosePrice;
            self.closeTime = parseInt(positionData.CloseTime + '000', 10);
            self.contractSize = positionData.ContractSize;
            self.action = Const.actionsId[positionData.Cmd];
            self.actionCode = positionData.Cmd;
            self.symbolId = positionData.id;
            self.outputName = positionData.OutputName;
            self.digits = positionData.Digits;
            self.lots = positionData.Volume;
            self.amount = self.contractSize * self.lots;
            self.stopLoss = positionData.sl;
            self.takeProfit = positionData.tp;
            self.commission = positionData.Commission;
            self.taxes = positionData.Taxes;
            self.swap = positionData.Storage;
            self.profit = positionData.Profit;
            self.comment = positionData.Comment;
            self.tradeAction = setTradeAction(positionData.Cmd)
            asset = AssetService.collection.get({id: positionData.id});

            self.convAssets = CurrencyConvertService.find(AssetService, self.user.currency, 'USD', '', 1);
            if (asset) {
                self.symbolCurrency = asset.currency;
            }

            this.profitToUsd = function () {
                return CurrencyConvertService.doConvert(self.convAssets, self.profit, 'buy', 1);
            };

            this.clear = function () {
                asset = null;
            }

            function setTradeAction(cmd) {
                if (cmd < 6) {
                    return "trades"
                }
                if (cmd === 6) {
                    return "balance"
                }
                if (cmd === 7) {
                    return "credit"
                }
                return "other"
            }

            this.fromSocial = function() {
                return /^S:/.test(self.comment);
            }

        }

        return ClosedTrade;

    }]);
